import http from '@/utils/http';

export default {
  async getById(id) {
    return await http.get(`/api/app_user/get/${id}`);
  },
  async insert(data) {
    return await http.post('/api/app_user/insert', data);
  },
  async update(data) {
    return await http.post('/api/app_user/update', data);
  },
  async delete(data) {
    return await http.post('/api/app_user/delete', data);
  }
};